export default {"src":"/_next/static/media/settings-active-icon.2ada74df.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};